import { I18n } from "react-redux-i18n";

export const enumToOptions = (obj: Record<string, string>, internationalisationPath: string) =>
  Object.values(obj)
    .map(value => ({
      value,
      text: I18n.t(`${internationalisationPath}.${value}`),
    }));
